/**
 * Please, do not change this URL. There should actually only be one instance of the NOE
 * website, and this should be at this URL. It helps also crediting our work ! Thanks :)
 */
export const WEBSITE_URL =
  process.env.NODE_ENV === "production" && process.env.REACT_APP_WEBSITE_URL
    ? "https://get.noe-app.io"
    : (process.env.REACT_APP_WEBSITE_URL as string);

/**
 * Some constant URLs
 */
export const WEBSITE_URLS = {
  HOME: WEBSITE_URL,
  DOCS: `${WEBSITE_URL}/docs`,
  CONTACT: `${WEBSITE_URL}/contact`,
  DONATE: `${WEBSITE_URL}/donate`,
  HELP_CENTER: `${WEBSITE_URL}/community/help-center`,
};
export const DISCORD_INVITE_LINK = "https://discord.gg/hdrJnFqmXJ";
export const GITLAB_URL = "https://gitlab.com/noe-app/noe";
